var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallArrowheadForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e9v79jblua",
    d: "M0 0H14V8H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-779 -1950) translate(653 1942) matrix(0 1 1 0 126 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zmmeczwxsb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e9v79jblua"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8D8E97",
    d: "M3.256 3.371l6.23-6.12c.362-.335.917-.335 1.258 0 .341.336.341.88 0 1.237L5.134 4l5.61 5.512c.341.335.341.901 0 1.237-.341.335-.896.335-1.259 0L3.256 4.608c-.341-.336-.341-.88 0-1.237z",
    mask: "url(#zmmeczwxsb)",
    transform: "rotate(-90 7 4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowheadForward);
export default __webpack_public_path__ + "static/media/small-arrowhead-forward.a03a92b5692d8c6e29ebb63073b2aef2.svg";
export { ForwardRef as ReactComponent };